/**
 * Created by tomers on 2/28/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/api-keys/apiKeysGalleryView.tmpl");

    var KpContent = require("ui.components/kpContent/kpContent");
    var ApiKeysGalleryComponent = require("ui.components/gallery/apiKeysGallery");
    var Ellipsis = require("ui.plugins/ellipsis");

    var ApiKeysGalleryView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        ApiKeysGalleryView = Marionette.ItemView.extend({
            template: template,
            className: "api-keys-gallery-view",
            ui: {
                kpContent: ".api-keys-gallery-kp",
                galleryContainer: ".gallery-container"
            },
            uiComponents: {
                gallery: {
                    type: ApiKeysGalleryComponent,
                    options: {
                        collection: "view.collection",
                        collectionMap: {
                            "isEditable": "isEditable",
                            "isViewable": "isViewable"
                        },
                        el: "view.ui.galleryContainer",
                        newItemToAdd: {
                            name: LE.translator.translate("LEFramework.global.captions.addNew")
                        },
                        selectableGallery: false
                    },
                    events: {
                        "click": "_onGalleryItemClick",
                        "edit": "_onGalleryItemEdit"
                    }
                },
                kpContent: {
                    type : KpContent,
                    options : {
                        container: "view.ui.kpContent",
                        KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                        kpID: "get-started-LE-APIs",
                        showKPIcon: true
                    }
                }
            },

            initialize: function (options) {
                this.channel = LEManager.media.channel("apiKeys");
                this.collection = LEManager.getModuleDataManager().getData(LEManager.getModuleDataManager().getEntities().API_KEYS_GALLERY);
            },

            onRender: function () {
                //we either do it here with deferred or on show( since the view can not know the parent is using region Show we do it here )
                _.defer(_.bind(function(){
                    Ellipsis.handleNow(this);
                }, this));

            },
            onClose: function() {
                LEManager.logger.debug("closing API keys gallery", "ApiKeysGalleryView:onClose");
            },

            _onGalleryItemClick: function(componentId, eventName, value) {
                if (value === ApiKeysGalleryComponent.NEW_ITEM_KEY) {
                    LEManager.logger.info("New gallery Item clicked", "ApiKeysGalleryView:onGalleryItemClick");
                    this.channel.trigger("apiKeys:create");
                }
            },

            _onGalleryItemEdit: function(componentId, eventName, itemId) {
                LEManager.logger.info("Edit gallery item clicked", "ApiKeysGalleryView:onGalleryItemEdit");
                this.channel.trigger("apiKeys:edit", itemId);
            }
        });

    }

    LE.module("LEManager", moduleDefinition);

    return ApiKeysGalleryView;
});
